
import axios from "axios"
import ApiStore from "./ApiStore";
var querystring = require('querystring');


export class DPDocStore extends ApiStore{
  constructor() {
    super();
  }

  newDPDoc(completeFunc){
    axios.get('/deposit/doc/?format=json&new_dp=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  newDPDocFromWork(workNo,completeFunc){
    axios.get('/deposit/doc/?format=json&new_dp=true&wo='+workNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  

  loadDPDoc(poNo,completeFunc){
    axios.get('/deposit/doc/?format=json&dp='+poNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadDPDocHistory(docType,dpNo,completeFunc){
    axios.get('/deposit/history/'+docType+'?format=json&dp='+dpNo)
    .then(function(response){
      
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadSupplierList(query,pageNo,completeFunc){
    axios.get('/deposit/supplierlist/?format=json&q='+query+'&page='+pageNo)
    .then(function(response){
      
      completeFunc(response.data)
    })
    .catch(function (error) {
      
    })
  }

  loadWorkRecord(workNo,completeFunc,errorFunc){
    axios.get('/deposit/work_record/?format=json&wo='+workNo)
    .then(function(response){
      
      completeFunc(response.data)
    })
    .catch(function (error) {
      
      errorFunc(error)
    })
  }

  saveDPDoc(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/deposit/doc/',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  updateDPDocStatus(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/deposit/status/',querystring.stringify(postData))
    .then(function(response){
      console.log('response',response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }
  
  delSupplier(customerId,completeFunc,errorFunc){
    
    console.log('supplier',customerId)
    axios.delete('/deposit/supplier/'+customerId)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  cancelDPDoc(dpNo,stock_recordid,completeFunc,errorFunc){
        
    dpNo = dpNo.replace("/", "_");
    axios.post('/deposit/cancel/'+dpNo,querystring.stringify({recordid:stock_recordid}))
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delDPDoc(dpNo,completeFunc,errorFunc){
        
    dpNo = dpNo.replace("/", "_");
    axios.delete('/deposit/doc/'+dpNo)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveSupplier(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)
    axios.post('/deposit/supplier/'+postData.shop_id,querystring.stringify(postData))
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }
}

export default new DPDocStore()



// WEBPACK FOOTER //
// ./src/stores/DPDocStore.js